<template>
  <!-- 全局弹窗 -->
  <s-popup v-model="isShow" :maskClose="false" position="center">
    <view style="width: 600rpx">
      <view class="my-confirm-content">
        <view>
          尊敬的用户，您好，感谢您一直以来对本商城的关注与支持。为了加强对您的个人保护，根据最新法律法规要求，我们已于
          {{ dateFormat(updateTime, 'yyyy年MM月dd日') }}
          更新了隐私政策和服务协议，请您仔细阅读并确认以下内容，我们将严格按照法律法规及协议政策约定收集、使用和保护您的个人信息，感谢您的信任。
          <view style="color: #01a7f0" @click.stop="skip('PRIVACY_AGREEMENT')">《隐私政策》</view>
          <view style="color: #01a7f0" @click="skip('SERVICE_AGREEMENT')">《服务协议》</view>
        </view>
      </view>
      <view class="my-operation">
        <view class="confirm-btn" @click="onClick('clickConfirm')">
          <p class="my-btn-text my-btn-confirm my-border-right">同意,继续使用</p>
        </view>
        <view class="my-cancel-btn" @click="onClick('clickCancel')">
          <p class="my-btn-text my-btn-cancle">拒绝,退出商城</p>
        </view>
      </view>
    </view>
  </s-popup>
</template>

<script>
import jump from '@/utils/jump';
import { mapState } from 'vuex';
import { throttle } from '@/utils/enhance';
import { agreeAgreementNotice } from '@/api/marketing';

export default {
  name: 'SystemPop',
  data() {
    return {
      isShow: false,
      updateTime: '',
    };
  },
  computed: {
    ...mapState({
      globalPop: state => state.systemPop.global,
    }),
  },
  watch: {
    globalPop: {
      handler(val) {
        const { isPricacyShow = false, publishDate = '' } = val || {};
        this.isShow = isPricacyShow;
        this.updateTime = publishDate;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onClick(type) {
      // 点击协议按钮，清除store全局弹窗数据，触发弹窗关闭
      if (this.isShow) {
        this.$setVuex('systemPop.global', null);
        // 当前弹窗关闭后，不连续弹窗会员级弹窗
        this.$setVuex('systemPop.enableMemberFetch', false);
      }

      // 拒绝
      if (type === 'clickCancel') {
        this.$store.dispatch('logout');
        jump.to('/pages/login/login');
        return;
      }
      // 同意
      agreeAgreementNotice().then(res => {
        if (!res.success) {
          alert(res.msg);
        }
      });
    },
    // 跳转协议
    skip(type) {
      throttle(() => {
        this.$api.featureGetByCategory(type).then(res => {
          const id = res.data?.id || '';
          jump.to(`/pages/introduce/details/index?id=${id}`);
        });
      }, 1000)();
    },
  },
};
</script>

<style scoped scoped>
/* 中间内容部分 */
.my-confirm-content {
  padding: 0 30rpx;
  padding-top: 20px;
  margin-bottom: 24rpx;
  font-size: 32rpx;
  color: #666;
  line-height: 1.5;
}

/* 底部按钮样式 */
.my-operation {
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-top: 1px solid #eee;
}
.my-operation .my-cancel-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
}
.my-operation .confirm-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.my-operation .my-btn-text {
  text-align: center;
  font-size: 32rpx;
  margin: 28rpx 0;
  padding: 0 10rpx;
  /* width: 200rpx; */
  line-height: 70rpx;
  border-radius: 5px;
}
.my-btn-confirm {
  background: #d7092f;
}
.my-btn-cancle {
  border: 1px solid #999;
}
/* 其他修饰样式 */
.my-border-right {
  border-right: 1px solid #eee;
}
</style>
